import { useSelectionContext } from 'common/contexts/SelectionContext';
import * as React from 'react';

export const SelectionToolbar: React.FC = () => {
  const { selection, setSelection } = useSelectionContext();

  const handleSelectAll = React.useCallback(() => {
    setSelection((s) => ({ model: 'filter', totalCount: s.model === 'none' ? 0 : s.totalCount }));
  }, [setSelection]);

  let content: React.ReactNode | null = null;
  if (selection.model !== 'none') {
    if (selection.model === 'page' && selection.containers.length !== selection.totalCount) {
      content = (
        <>
          <h5>{selection.containers.length} rows in view selected.</h5>
          <h5 className="text-blue-900 underline cursor-pointer" onClick={handleSelectAll}>
            select all table rows instead ({selection.totalCount})
          </h5>
        </>
      );
    } else {
      content = <h5>All table rows selected ({selection.totalCount})</h5>;
    }
  }

  return (
    <div
      className="bg-orange-50 px-4 w-screen border-b border-blue-200 flex space-x-1 h-8 items-center shadow-sm"
      style={{ position: 'absolute', top: '3rem', zIndex: 10 }}
    >
      {content}
    </div>
  );
};
SelectionToolbar.displayName = 'ContainerActions.SelectionToolbar';
